import { Event, relativeTarget, nodeArray } from 'meteora';
import MobileMenu from '../classes/mobile-menu';
document.addEventListener('DOMContentLoaded', function () {
  var menu = new MobileMenu(document.querySelector('.js-mobile-menu'));

  // Site Search
  var searches = nodeArray(document.querySelectorAll('.js-search'));
  searches.forEach(function (search) {
    var searchForm = search.querySelector('form');
    var searchField = search.querySelector('#SearchForm_SearchForm_Search');
    var searchHolder = search.querySelector('#SearchForm_SearchForm_Search_Holder');
    var searchControl = search.querySelector('.js-search--control');
    // A custom submit event
    var searchEvent = new Event('submit');
    searchControl.addEventListener('click', function (e) {
      // Test to see if it is already active
      if (search.classList.contains('js-active')) {
        // A small validation to check there is a value
        if (searchField.value === '') {
          // hide the form
          search.classList.remove('js-active');
          setTimeout(function () {
            return searchHolder.style.display = 'none';
          }, 300);
          return;
        }
      } else {
        // Show the form
        searchHolder.style.display = 'block';
        setTimeout(function () {
          search.classList.add('js-active');
          searchField.focus();
        }, 5);
        return;
      }

      // Search the value if there is a value
      searchForm.dispatchEvent(searchEvent);
    });

    // Close the search if we click somewhere else entirely 
    window.addEventListener('click', function (e) {
      if (search.classList.contains('js-active') & !relativeTarget(e.target, search)) {
        search.classList.remove('js-active');
      }
    });
  });
  var mobileNav = document.querySelector('.js-mobile-menu');
  var mobileOpen = document.querySelector('.js-mobile-menu--open');
  var mobileClose = document.querySelector('.js-mobile-menu--close');
  var mobileToggle = null;
  mobileOpen.addEventListener('click', function () {
    clearTimeout(mobileToggle);
    mobileNav.style.display = 'block';

    // mobileNav.Equalizer.update();

    window.ScrollLocker.lock();
    mobileToggle = setTimeout(function () {
      mobileNav.style.opacity = 1;
    }, 5);
  });
  mobileClose.addEventListener('click', function () {
    clearTimeout(mobileToggle);
    mobileNav.style.opacity = 0;

    // mobileNav.Equalizer.update();

    window.ScrollLocker.unlock();
    mobileToggle = setTimeout(function () {
      mobileNav.style.display = 'none';
    }, 300);
  });

  // setTimeout(() => {
  //   window.ScrollLocker.lock();
  //   setTimeout(() => {
  //     window.ScrollLocker.unlock();
  //   }, 5000);
  // }, 5000);
});